import { type GooseEvent, type EventCategory } from './eventNames.types';

export const ALTERNATIVE_DATES_EVENTS_BY_CATEGORY = {
  INTERACTION: {},
  BEHAVIOURAL: {
    PRICE_GRID_SEARCH_RESULTS: {
      NAME: 'price_grid_search_results',
      OWNER: 'Goose',
    },
    USER_CLICKED_MINI_GRID_DATE: {
      NAME: 'user_clicked_mini_grid_date',
      OWNER: 'Goose',
    },
    PRICE_GRID_CELL_CLICK: {
      NAME: 'price_grid_cell_click',
      OWNER: 'Goose',
    },
    PRICE_GRID_DATE_SEARCH: {
      NAME: 'price_grid_date_search',
      OWNER: 'Goose',
    },
    PRICE_GRID_DIRECT_FLIGHTS_TOGGLE: {
      NAME: 'price_grid_direct_flights_toggle',
      OWNER: 'Goose',
    },
    PRICE_GRID_OPENED_MINI_GRID: {
      NAME: 'price_grid_opened_mini_grid',
      OWNER: 'Goose',
    },
    PRICE_GRID_FIND_FLIGHTS_CLICK: {
      NAME: 'price_grid_find_flights_click',
      OWNER: 'Goose',
    },
  },
  MINIEVENT_MISC: {
    NO_FLIGHTS_LOADED: {
      NAME: 'No_Flights_Loaded',
      OWNER: 'Goose',
    },
    DAY_VIEW_SAVE_TO_LIST_INTERACTION: {
      NAME: 'day_view_save_to_list_interaction',
      OWNER: 'Goose',
    },
    DAYVIEW_LATENCY: {
      NAME: 'dayview_latency',
      OWNER: 'Goose',
    },
    LIVE_PRICES_DISPLAYED: {
      NAME: 'live_prices_displayed',
      OWNER: 'Goose',
    },
    DAY_VIEW_RESULT_SELECTED: {
      NAME: 'day_view_result_selected',
      OWNER: 'Goose',
    },
    DAY_VIEW_NAVIGATE_TO_SAVED_LIST: {
      NAME: 'day_view_navigate_to_saved_list',
      OWNER: 'Goose',
    },
  },
  SMART_METRICS: {
    FLIGHTS_DAY_VIEW_LOADED: {
      NAME: 'flights_day_view_loaded',
      OWNER: 'Goose',
    },
    FLIGHTS_DAY_VIEW_NO_RESULTS_RENDERED: {
      NAME: 'flights_day_view_no_results_rendered',
      OWNER: 'Goose',
    },
    DAYVIEW_FIRST_RESULT_SHOWN: {
      NAME: 'dayview_first_result_shown',
      OWNER: 'Goose',
    },
    DAYVIEW_COMPLETED: {
      NAME: 'dayview_completed',
      OWNER: 'Goose',
    },
    CLICK_FLIGHTS_SHOW_MORE_BUTTON: {
      NAME: 'click_flights_show_more_button',
      OWNER: 'Goose',
    },
  },
} as const satisfies Record<EventCategory, Record<string, GooseEvent>>;
